import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, AuthCard, AuthField, Button, ErrorBanner } from '@scoring/frontend-shared';

/**
 * Login page — authenticates participant users via Cognito.
 * Redirects to dashboard on success.
 */
export function LoginPage(): JSX.Element {
  const { signIn, status } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  if (status === 'authenticated') {
    void navigate('/', { replace: true });
  }

  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await signIn({ email, password });
      void navigate('/', { replace: true });
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Authentication failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard title="Participant Sign In" subtitle="View your scores and station progress">
      {error && <ErrorBanner>{error}</ErrorBanner>}
      <form onSubmit={(e) => void handleSubmit(e)}>
        <AuthField id="email" label="Email" type="email" value={email} onChange={setEmail} autoComplete="email" required />
        <AuthField id="password" label="Password" type="password" value={password} onChange={setPassword} autoComplete="current-password" required />
        <Button type="submit" block disabled={loading}>
          {loading ? 'Signing in…' : 'Sign In'}
        </Button>
      </form>
    </AuthCard>
  );
}
